import React from 'react';
import { MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { openDialog } from '@/features/dialog/dialogSlice';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

export const CrmProfileMenuItem = ({ onClose }) => {
	const dispatch = useDispatch();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });

	return (
		<MenuItem
			onClick={() => {
				dispatch(
					openDialog({
						dialogName: 'userProfile',
						data: { userId: userDetails?.userId },
					}),
				);
				onClose();
			}}
		>
			Profile
		</MenuItem>
	);
};
